import React, { useState, useEffect } from "react";
import add from "../../images/add.svg";
import DialogComponent from "../reusableComponents/Dialog";
import { toast } from "react-toastify";
import { Box, Grid, Typography } from "@mui/material";
import moment from "moment";
import deleteIcon from "../../images/delete.png";
import DeleteDialog from "../reusableComponents/DeleteDialog";
import billImg from "../../images/bill.png";
import AddVoucher from "./AddVoucher";
import Search from "../components/Search";
import { Header, TopGrid, BodyContainer, ButtonAdd } from "../styles";
import DateField from "../components/DateField";
import Loader from "../components/Loader";
import { TableHead, TableRow } from "./styles";
import Repo from "../../Repository/Repo";

function VouchersList() {
  const [vouchers, setVouchers] = useState([]);
  const [state, setState] = useState({
    loading: false,
    searchText: "",
    date: "",
    addModal: "",
    selectedId: "",
    deleteModal: "",
  });

  useEffect(() => {
    getVouchers();
  }, []);

  const getVouchers = async () => {
    setState((prev) => ({ ...prev, loading: true }));
    let { data } = await Repo.voucher({
      request: {
        method: "getVouchersByCompany",
        data: {
          company_code: localStorage.getItem("companyCode"),
        },
      },
    });
    setVouchers(data.response.data.vouchers);
    setState((prev) => ({ ...prev, loading: false }));
  };

  const deleteVoucher = async () => {
    setState((prev) => ({ ...prev, loading: true }));
    let { data } = await Repo.voucher({
      request: {
        method: "deleteVoucher",
        data: {
          _id: state.selectedId,
        },
      },
    });
    if (data.response.status.statusCode == 200) {
      toast.configure();
      toast.info("Voucher Deleted");
    } else {
      toast.configure();
      toast.error("Voucher Not Deleted");
    }
    setState((prev) => ({ ...prev, deleteModal: false, loading: false }));
    getVouchers();
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const toggle = (name) => {
    setState((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  const deleteToggle = (id) => {
    setState((prev) => ({ ...prev, selectedId: id, deleteModal: true }));
  };

  const searchedItems = () => {
    if (state.searchText != "") {
      const filtered = vouchers.filter((item) =>
        item?.ledgerName?.toLowerCase().includes(state.searchText)
      );
      return filtered;
    } else if (state.date != "") {
      const filtered = vouchers.filter(
        (filterItem) =>
          moment(filterItem.date).format("DD-MM-YYYY") ==
          moment(state.date).format("DD-MM-YYYY")
      );
      return filtered;
    } else {
      return vouchers;
    }
  };

  return (
    <Box>
      <Header sx={{ mt: { md: "0px", xs: "40px" } }}>
        <TopGrid container alignItems="center" spacing={1}>
          <Grid item md={3} xs={12}>
            <Search
              name={"searchText"}
              text={"Search item..."}
              value={state.searchText}
              onChange={handleInput}
            />
          </Grid>
          <Grid align="center" item lg={6} md={4} xs={12}>
            <Typography variant="h5" sx={{ color: "white" }}>
              Vouchers
            </Typography>
          </Grid>
          <Grid align="center" item lg={2} md={4} xs={6}>
            <DateField
              name={"date"}
              value={state.date}
              onChange={handleInput}
            />
          </Grid>
          <Grid align="center" item lg={1} md={1} xs={6}>
            <ButtonAdd variant="contained" onClick={() => toggle("addModal")}>
              Add
              <img src={add} alt="add" />
            </ButtonAdd>
          </Grid>
        </TopGrid>
      </Header>
      <BodyContainer sx={{ mb: 3 }}>
        <TableHead container columns={24}>
          <Grid item lg={1} md={1} xs={1}>
            <Typography
              sx={{ color: "#4EAF50", fontSize: { md: "16px", xs: "8px" } }}
            >
              #
            </Typography>
          </Grid>
          <Grid item lg={2} md={2} sm={2} xs={2}>
            <Typography
              sx={{
                color: "#4EAF50",
                fontSize: { md: "16px", xs: "8px" },
                ml: { md: "0px", xs: "-4px" },
              }}
            >
              Preview
            </Typography>
          </Grid>
          <Grid item lg={2} md={2} sm={2} xs={2}>
            <Typography
              sx={{ color: "#4EAF50", fontSize: { md: "16px", xs: "8px" } }}
            >
              Paid
            </Typography>
          </Grid>
          <Grid item lg={2} md={2} sm={2} xs={2}>
            <Typography
              sx={{
                color: "#4EAF50",
                fontSize: { md: "16px", xs: "8px" },
                ml: { md: "0px", xs: "-4px" },
              }}
            >
              Received
            </Typography>
          </Grid>
          <Grid item lg={3} md={3} sm={3} xs={3}>
            <Typography
              sx={{ color: "#4EAF50", fontSize: { md: "16px", xs: "8px" } }}
            >
              Discount
            </Typography>
          </Grid>
          <Grid item lg={3} md={3} sm={3} xs={3}>
            <Typography
              sx={{ color: "#4EAF50", fontSize: { md: "16px", xs: "8px" } }}
            >
              Total
            </Typography>
          </Grid>
          <Grid item lg={4} md={4} sm={4} xs={4}>
            <Typography
              sx={{ color: "#4EAF50", fontSize: { md: "16px", xs: "8px" } }}
            >
              Ledger Name
            </Typography>
          </Grid>
          <Grid item lg={4} md={4} sm={4} xs={4}>
            <Typography
              sx={{ color: "#4EAF50", fontSize: { md: "16px", xs: "8px" } }}
            >
              Description
            </Typography>
          </Grid>
          <Grid item lg={2} md={2} sm={2} xs={2}>
            <Typography
              sx={{ color: "#4EAF50", fontSize: { md: "16px", xs: "8px" } }}
            >
              Date
            </Typography>
          </Grid>
        </TableHead>

        {searchedItems()?.map((item, index) => {
          return (
            <TableRow key={index} container columns={24}>
              <Grid item xs={1}>
                <Typography sx={{ fontSize: { md: "16px", xs: "8px" } }}>
                  {index + 1}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <img
                  src={billImg}
                  style={{ cursor: "pointer" }}
                  className="img-w-15"
                  height="50px"
                  onClick={() => print(item, "old")}
                />
              </Grid>
              <Grid item xs={2}>
                <Typography sx={{ fontSize: { md: "16px", xs: "8px" } }}>
                  {item.paid}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography sx={{ fontSize: { md: "16px", xs: "8px" } }}>
                  {item.received}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography sx={{ fontSize: { md: "16px", xs: "8px" } }}>
                  {item.discount}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography sx={{ fontSize: { md: "16px", xs: "8px" } }}>
                  {item.totalKhata}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography sx={{ fontSize: { md: "16px", xs: "8px" } }}>
                  {item.ledgerName}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography sx={{ fontSize: { md: "16px", xs: "8px" } }}>
                  {item.description}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography sx={{ fontSize: { md: "16px", xs: "8px" } }}>
                  {moment(item.date).format("DD-MM-YYYY")}
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <img
                  style={{ cursor: "pointer", float: "right" }}
                  src={deleteIcon}
                  alt="delete"
                  onClick={() => deleteToggle(item._id)}
                  className="w-10"
                />
              </Grid>
            </TableRow>
          );
        })}
      </BodyContainer>

      <DialogComponent
        title="Add Voucher"
        open={state.addModal}
        onClose={() => toggle("addModal")}
        onClickCancel={() => toggle("addModal")}
        dialogContent={
          <AddVoucher
            onClose={() => toggle("addModal")}
            onSuccess={getVouchers}
          />
        }
      />

      <DeleteDialog
        title="Delete Voucher"
        open={state.deleteModal}
        onClose={() => toggle("deleteModal")}
        onClickYes={deleteVoucher}
      />
      <Loader loading={state.loading} />
    </Box>
  );
}

export default VouchersList;
